import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import EventTypeBadge from './EventTypeBadge';

const BANNER_HEIGHT = 220;

const BannerRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isArchived',
})(({ isArchived }) => ({
  position: 'relative',
  borderRadius: 12,
  overflow: 'hidden',
  height: BANNER_HEIGHT,
  backgroundColor: '#000',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  ...(isArchived
    ? {
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.06)',
      }
    : {}),
}));

const CoverFrame = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isArchived',
})(({ isArchived }) => ({
  width: BANNER_HEIGHT,
  height: BANNER_HEIGHT,
  flexShrink: 0,
  position: 'relative',
  overflow: 'hidden',
  ...(isArchived
    ? {
        filter: 'grayscale(1)',
        opacity: 0.72,
      }
    : {}),
}));

const CoverImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
});

const PlaceholderCover = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isArchived',
})(({ isArchived }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: isArchived ? '#6b6b6b' : '#1a1a2e',
}));

const Overlay = styled(Box)({
  position: 'absolute',
  inset: 0,
  background: 'linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.55) 100%)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: 20,
});

const EventDetailsBanner = ({ event, isArchived = false }) => (
  <BannerRoot isArchived={isArchived}>
    <CoverFrame isArchived={isArchived}>
      {event.coverImageUrl ? (
        <CoverImage src={event.coverImageUrl} alt="" />
      ) : (
        <PlaceholderCover isArchived={isArchived} />
      )}
    </CoverFrame>
    <Overlay
      sx={
        isArchived
          ? {
              background: 'linear-gradient(180deg, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.45) 100%)',
            }
          : undefined
      }
    >
      <Box
        sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}
      >
        <EventTypeBadge type={event.type} />
        {isArchived ? (
          <Chip
            label="Archived"
            size="small"
            sx={{
              height: 26,
              fontWeight: 700,
              fontSize: '0.75rem',
              bgcolor: 'rgba(255,255,255,0.92)',
              color: '#5c534a',
              border: '1px solid rgba(0,0,0,0.08)',
            }}
          />
        ) : null}
      </Box>
      <Typography
        variant="h5"
        sx={{
          color: '#fff',
          fontWeight: 700,
          fontSize: { xs: '1.25rem', sm: '1.5rem' },
          lineHeight: 1.3,
        }}
      >
        {event.title}
      </Typography>
    </Overlay>
  </BannerRoot>
);

export default EventDetailsBanner;
